<template>
  <el-drawer class="sideDrawer" destroy-on-close :size="drawerSize" :wrapperClosable="false" title="开票" :visible="detailShow" :before-close="closeDetail"
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">开票</span>
    </div>
    <div class="form_content" style="padding: 20px">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <div class="titlePart">
          <span>客户信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票申请单号:" prop="audit_no">
              <el-input v-model="formData.audit_no" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customer_name">
              <el-input v-model="formData.customer_name" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人:" prop="contacts">
              <el-input v-model="formData.contacts" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话:" prop="contacts_phone">
              <el-input v-model="formData.contacts_phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="地址:" prop="receiver_address">
              <el-input v-model="formData.receiver_address" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱:" prop="receiver_meal">
              <el-input v-model="formData.receiver_meal" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请发票金额:" prop="apply_amount">
              <el-input-number
                style="width: 100%"
                :precision="2"
                v-model="formData.apply_amount"
                :min="0"
                :max="9999999999"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型:" prop="invoice_type">
              <el-select v-model="formData.invoice_type" style="width: 100%" placeholder="请选择" disabled>
                <el-option v-for="item in productList" :key="item.index" :label="item.name" :value="item.key"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请日期:" prop="apply_date">
              <el-date-picker v-model="formData.apply_date" style="width: 100%" value-format="yyyy-MM-dd" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="titlePart">
          <span>开票信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票抬头名称:" prop="invoice_title">
              <el-input v-model="formData.invoice_title" disabled> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税人识别号:" prop="identity_code">
              <el-input v-model="formData.identity_code" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开户行及账号:" prop="bank_account">
              <el-input v-model="formData.bank_account" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址电话:" prop="address_phone">
              <el-input v-model="formData.address_phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="titlePart">
          <span>付款单信息</span>
        </div>
        <el-table :data="formData.sub_third_invoice_order" style="width: 100%" max-height="250">
          <el-table-column label="序号" type="index" width="50"> </el-table-column>
          <el-table-column prop="payment_no" label="付款单号"> </el-table-column>
          <el-table-column prop="payment_amount" label="付款金额" :formatter="num_formatter1"> </el-table-column>
          <el-table-column prop="pay_amount" label="确认收款" :formatter="num_formatter1"> </el-table-column>
        </el-table>
        <div style="margin-top: 20px" v-if="formData.sub_third_invoice_confirm && formData.sub_third_invoice_confirm.length">
          <div class="titlePart">
            <span>开票确认</span>
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="实际开票金额:" prop="invoice_amount">
                <el-input-number
                  :precision="2"
                  v-model="sub_third_invoice_confirm.invoice_amount"
                  :min="0"
                  :max="9999999999"
                  :controls="false"
                  disabled
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="开票人:" prop="reviewer_name">
                <el-input disabled v-model="sub_third_invoice_confirm.reviewer_name" type="text"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话:" prop="reviewer_phone">
                <el-input v-model="sub_third_invoice_confirm.reviewer_phone" disabled type="text"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票日期" prop="audit_date">
                <el-date-picker v-model="sub_third_invoice_confirm.audit_date" disabled type="date" value-format="yyyy-MM-dd" placeholder="选择开票日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="快递单号:" prop="courier_number">
                <el-input disabled v-model="sub_third_invoice_confirm.courier_number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="附件:" prop="attachment">
            <eip-attachment
              v-model="sub_third_invoice_confirm.attachment"
              model-name="sub_third_invoice_confirm.attachment"
              :permission="'w'"
              propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
              accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
              limit="10"
              displayType="table"
              isInputEdit=""
              :configAttributes="{}"
              :multiple="true"
            >
              <span slot="labeldesc">附件</span>
            </eip-attachment>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import smallTable from './smallTable.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import FormInput from '../billingCenter/formInput.vue'
export default {
  components: { smallTable, FormInput },
  props: ['show', 'detailId'],
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  data() {
    return {
      drawerSize: '70%',
      sub_third_invoice_confirm: {},
      tenantId: '',
      productList: [],
      detailShow: false,
      loading: false,
      formData: {
        apply_date: moment(new Date()).format('YYYY-MM-DD')
      },
      rules: {
        receiver_address: [
          { required: true, message: '请输入地址', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        contacts_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        receiver_meal: [
          { required: false, message: '请输入邮箱', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        invoice_title: [
          { required: true, message: '请输入发票抬头名称', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        identity_code: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        invoice_type: [
          {
            required: true,
            message: '请选择发票类型',
            trigger: ['blur', 'change']
          }
        ],
        bank_account: [
          { required: true, message: '请输入开户行及账号', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ],
        address_phone: [
          { required: true, message: '请输入地址电话', trigger: 'blur' },
          { max: 200, message: '字数不得超过200', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    detailId: {
      handler(newVal, oldVal) {
        if (newVal) this.getDetail(newVal)
      },
      deep: true,
      immediate: true
    },
    show: {
      handler(newVal, oldVal) {
        this.detailShow = newVal
        this.getProductList()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取详情
    getDetail(id) {
      this.$http.get('${third}/costcenter/third_invoice_apply/' + id).then(
        (resp) => {
          if (resp.data) {
            if (resp.data.sub_third_invoice_confirm && resp.data.sub_third_invoice_confirm.length)
              this.sub_third_invoice_confirm = resp.data.sub_third_invoice_confirm[0]
            this.formData = resp.data
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 列表千分位格式化
    num_formatter1(row, column, cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },

    // 千分位格式化
    num_formatter(cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    },
    //关闭对话框
    closeDetail(isSave) {
      this.detailShow = false
      this.$emit('closeDetailDialog', isSave)
    },
    // 根据客户带出开票信息
    loadFRDetail() {
      const param = {
        pageBean: { page: 1, pageSize: 500, total: 0 }
      }
      this.$http.post('${portal}/system/tenant_corporate_info/query?tenantId=' + this.tenantId, param).then(
        (resp) => {
          if (resp.data && resp.data.rows && resp.data.rows.length > 0) {
            resp.data.rows.forEach((e) => {
              if (e.default == 1) {
                this.$set(this.formData, 'invoice_title', e.company_name)
                this.$set(this.formData, 'identity_code', e.tax_no)
                this.$set(this.formData, 'bank_account', `${e.bank ? e.bank : ''}` + `${e.bank_no ? e.bank_no : ''}`)
                this.$set(this.formData, 'address_phone', `${e.company_address ? e.company_address : ''}` + `${e.company_tel ? e.company_tel : ''}`)
              }
            })
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 获取发票类型列表
    getProductList() {
      this.productList = utils.findDictList('jxfpkplx', this.allDataDict)
    },
    // 下拉框赋值
    accountChange(val) {
      this.productList.forEach((item) => {
        if (item.key == val) {
          this.formData.invoice_type = item.key
          if (this.formData.invoice_type == 3 || this.formData.invoice_type == 4) {
            this.rules.receiver_meal = [
              { required: true, message: '请输入邮箱', trigger: 'blur' },
              { max: 200, message: '字数不得超过200', trigger: 'blur' }
            ]
          } else {
            this.rules.receiver_meal = [
              { required: false, message: '请输入邮箱', trigger: 'blur' },
              { max: 200, message: '字数不得超过200', trigger: 'blur' }
            ]
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  padding: 0;
  margin: 0;
}
.detailContent {
  padding-left: 20px;
  padding-right: 20px;
}
.eachItem {
  display: flex;
  .label {
    margin-right: 20px;
    flex-shrink: 0;
  }
  p {
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: left;
    line-height: 2;
  }
}
/deep/.el-dialog__body {
  padding-top: 20px;
}
.titlePart {
  display: flex;
  align-content: center;
  margin-bottom: 10px;
  img {
    height: 20px;
  }
  span {
    color: rgba(55, 124, 255, 100);
    font-size: 16px;
    font-weight: bold;
  }
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
